export function renderThreadDetailDrawerShell(contentHTML) {
  return `
    <div class="detail-drawer-overlay" data-action="close-drawer"></div>
    <aside class="detail-drawer">
      <button class="detail-drawer__close" data-action="close-drawer">X</button>
      ${contentHTML}
    </aside>
  `;
}

export function renderThreadDetailTurnsSection(turnsHTML) {
  return `
    <div class="panel-eyebrow" style="margin-top:var(--space-md)">Thread turns</div>
    <div class="list">${turnsHTML}</div>
  `;
}

export function renderThreadDeleteAction() {
  return `
    <div class="button-row" style="margin-top:var(--space-md)">
      <button class="button button--sm button--danger" type="button" data-action="delete-thread">Delete thread</button>
    </div>
  `;
}
